<template>
  <div class="main-out">
    <div class="header">
      <div class="header-content">
        <h1>Alle Aufträge</h1>
      </div>
      <div class="menue">
        <router-link :to="`/manage/mitarbeiter`" class="option">Aufträge</router-link>
        <router-link :to="`/manage/mitarbeitererledigt`" id="selected" class="option">Erledigt</router-link>
      </div>
    </div>
    <div class="aufträge" @dragover.prevent @drop="handleDrop">
      <div
        v-for="(auftrag, index) in aufträge"
        :key="auftrag.id"
        :class="['auftrag', { deleted: auftrag.deleted, completed: auftrag.completed }]"
        draggable="true"
        :data-index="index"
        @dragstart="handleDragStart($event, index)"
        @dragenter="handleDragEnter($event, index)"
        @dragover.prevent="handleDragOver($event)"
        @dragleave="handleDragLeave($event, index)"
        @dragend="handleDragEnd($event)"
      >
        <div class="auftrag-content">
          <h1 class="h11">{{ auftrag.title }}</h1>
          <p class="address">{{ auftrag.address }} - {{ auftrag.customer }}</p>
          <p class="time">Vereinbart um: {{ auftrag.time }}</p>
          <div class="dauer">{{ auftrag.duration }}</div>
          <div class="worker">{{ auftrag.worker }}</div>
        </div>
        <div class="button-container">
          <button class="remove-btn" @click="openAbhakenModal(auftrag.id)" v-if="auftrag.completed">Abhaken</button>
        </div>
      </div>
    </div>

    <!-- Modal für Auftrag erledigt -->
    <div v-if="showAbhakenModal" class="modal-overlay" @click="showAbhakenModal = false">
      <div class="modal" @click.stop>
        <h2>Auftrag Abhaken</h2>
        <label>
          Titel:
          <input v-model="selectedAuftrag.title" type="text" />
        </label>
        <label>
          Auftragsnummer:
          <input v-model="selectedAuftrag.number" type="text" />
        </label>
        <label>
          Adresse:
          <input v-model="selectedAuftrag.address" type="text" />
        </label>
        <label>
          Kunde:
          <input v-model="selectedAuftrag.customer" type="text" />
        </label>
        <label>
          bearbeitet von:
          <input v-model="selectedAuftrag.worker" type="text" />
        </label>
        <label>
          datum:
          <input v-model="selectedAuftrag.date" type="text" />
        </label>
        <label>
          Fehlerbehebung:
          <input v-model="selectedAuftrag.fehler" type="text" />
        </label>
        <label>
          zeit ink. Fahrzeit:
          <input v-model="selectedAuftrag.zeit" type="text" />
        </label>
        <label>
          Werkstadt:
          <input v-model="selectedAuftrag.werkstattzeit" type="text" />
        </label>
        <label>
          zone:
          <input v-model="selectedAuftrag.zone" type="text" />
        </label>
        <label>
          Kommentare:kommentare

          <input v-model="selectedAuftrag.kommentare" type="text" />
        </label>


        <!-- Materialien anzeigen -->
<!-- Materialien anzeigen -->
<!-- Materialien anzeigen -->
<h3>Verwendete Materialien:</h3>
<ul v-if="selectedAuftrag.produktnamen && selectedAuftrag.quantities && selectedAuftrag.preise && selectedAuftrag">
  <li v-for="(product, index) in selectedAuftrag.produktnamen" :key="index" class="material-item">
    {{ product }} - {{ selectedAuftrag.quantities[index] }} Stück - Einzelpreis: {{ selectedAuftrag.preise[index].toFixed(2) }} € - Gesamtpreis: {{ (selectedAuftrag.preise[index] * selectedAuftrag.quantities[index]).toFixed(2) }} €
  </li>
</ul>
<p v-else>Keine Materialien benötigt.</p>



        <button @click="confirmAbhaken" style="background-color: #059669;">Bestätigen</button>
        <button @click="showAbhakenModal = false" style="background-color: #DC2626; margin-left: 10px;">Abbrechen</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useRoute } from 'vue-router';
import { keycloak } from '../keycloak';
axios.defaults.withCredentials = true;

const API_URL = ''; // URL entfernt

export default {
  setup() {
    const route = useRoute();
    const name = computed(() => route.params.name);

    const response = ref({
      currentLocation: 'Blumberg',
      aufträge: [],
    });

    axios.interceptors.request.use(config => {
      config.headers['Authorization'] = `Bearer ${keycloak.token}`;
      return config;
    }, error => {
      return Promise.reject(error);
    });

    const showAbhakenModal = ref(false);
    const aufträge = ref([]);
    const selectedAuftrag = ref({});
    const searchQuery = ref("");
    const searchResults = ref([]);
    const selectedMaterials = ref([]);

    const fetchAufträge = async () => {
      try {
        const response = await axios.post(`/api/alleauftaege/erledigt`);
        aufträge.value = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

+

    onMounted(fetchAufträge);

    const openAbhakenModal = async (auftragId) => {
      try {
        const response = await axios.get(`/api/auftraege/erledigt/${auftragId}`);
        selectedAuftrag.value = response.data;
        showAbhakenModal.value = true;
      } catch (error) {
        console.error('Error fetching Auftrag details:', error);
      }
    };

    const addMaterialToSelection = (material) => {
      const { id, produktname } = material;
      const preis = material.preis || material.price;

      if (id == null || produktname == null || preis == null) {
        console.error('Material fehlt wichtige Eigenschaften:', material);
        return;
      }

      const existingItem = selectedMaterials.value.find(
        (item) => item.material.id === id
      );

      if (existingItem) {
        existingItem.quantity++;
      } else {
        console.log(`Material hinzugefügt: ${produktname} (${preis} €)`);
        selectedMaterials.value.push({ material, quantity: 1, preis });

        if (!selectedAuftrag.value.produktnamen) {
          selectedAuftrag.value.produktnamen = [];
          selectedAuftrag.value.quantities = [];
          selectedAuftrag.value.preise = [];
        }

        selectedAuftrag.value.produktnamen.push(produktname);
        selectedAuftrag.value.quantities.push(1);
        selectedAuftrag.value.preise.push(preis);
      }
    };

    const removeMaterial = (index) => {
      selectedMaterials.value.splice(index, 1);
      selectedAuftrag.value.produktnamen.splice(index, 1);
      selectedAuftrag.value.quantities.splice(index, 1);
      selectedAuftrag.value.preise.splice(index, 1); // Preise auch entfernen
    };

    const changeMaterialQuantity = (index, delta) => {
      if (selectedAuftrag.value.quantities[index] + delta > 0) {
        selectedAuftrag.value.quantities[index] += delta;
      } else {
        removeMaterial(index);
      }
    };

    const materialInSelection = (material) => {
      return selectedMaterials.value.some(
        (item) => item.material.id === material.id
      );
    };

    const searchMaterials = async () => {
      console.log('searchquery: ' + searchQuery.value)
      if (searchQuery.value) {
        try {
          const response = await axios.get(`/api/materials/search`, {
            params: { query: searchQuery.value },
          });
          searchResults.value = response.data;
        } catch (error) {
          console.error("Fehler bei der Materials-Suche:", error);
        }
      } else {
        searchResults.value = [];
      }
    };

    const confirmAbhaken = () => {
      if (selectedAuftrag.value.id) {
        axios.delete(`/api/auftraege/erledigt/loeschen/${selectedAuftrag.value.id}`)
          .then(() => {
            selectedAuftrag.value.deleted = true;
            showAbhakenModal.value = false;
            fetchAufträge();
          })
          .catch(error => {
            console.error('Error beim Löschen des Auftrags:', error);
          });
      }
    };





    return {
      removeMaterial,
      changeMaterialQuantity,
      showAbhakenModal,
      aufträge,
      selectedAuftrag,
      searchQuery,
      searchResults,
      openAbhakenModal,
      addMaterialToSelection,
      materialInSelection,
      searchMaterials,
      confirmAbhaken,
    };
  },
};
</script>

<style>
/* Ihr vorhandenes CSS */
</style>



<style scoped> 
.options{
  background-color: #6B7280;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  margin-top: 10px;
}
.back-button {
  position: absolute;
  left: 0;
  padding: 10px 20px;
  border-radius: 8px;
  background-color: #1f2937; /* Dunklerer Hintergrund */
  text-decoration: none;
  color: #d1d5db; /* Heller Text */
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #374151; /* Hellere Hover-Farbe */
}

.main-out {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #111827; /* Dunkler Hintergrund */
  color: #D1D5DB; /* Heller Text */
  font-family: 'Inter', sans-serif;
  padding: 20px;
  box-sizing: border-box;
}

/* Header-Stile */
.header {
  text-align: center;
}

.header h1 {
  font-size: 2rem;
  color: #F3F4F6; /* Heller Text */
}

.menue {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 15px;
}

.option {
  padding: 10px 20px;
  border-radius: 8px;
  background-color: #1F2937; /* Dunkler Hintergrund */
  text-decoration: none;
  color: #D1D5DB; /* Heller Text */
  transition: background-color 0.3s;
}

.option:hover {
  background-color: #374151; /* Hellere Hover-Farbe */
}

#selected {
  outline: 2px solid #3B82F6; /* Blaue Umrandung */
}

/* Aufträge Container */
.aufträge {
  width: 100%;
  max-width: 800px; /* Größere Maximalbreite */
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr; /* Einspaltiges Layout */
  gap: 15px;
}

/* Einzelne Aufträge */
.auftrag {
  background-color: #1F2937; /* Dunkler Hintergrund */
  border-radius: 8px;
  padding: 20px;
  transition: transform 0.3s, background-color 0.3s;
  cursor: move;
}

.auftrag:hover {
  transform: translateY(-3px);
  background-color: #374151; /* Hellere Hover-Farbe */
}

.auftrag.deleted {
  background-color: #DC2626; /* Rote Farbe für gelöschte Aufträge */
  opacity: 0.8;
}

.auftrag.completed {
  background-color: #10B981; /* Grüne Farbe für erledigte Aufträge */
  opacity: 0.8;
}

/* Auftrag Details */
.auftrag-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.auftrag-title {
  font-size: 1.5rem;
  font-weight: 600;
}

.address,
.time,
.dauer,
.email,
.phone,
.date {
  font-size: 1rem;
}

/* Schaltflächen Container */
.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

/* Schaltflächen */
button {
  padding: 8px 15px;
  border-radius: 5px;
  border: none;
  font-size: 1rem;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}

.edit-btn {
  background-color: #3B82F6; /* Blaue Farbe */
}

.edit-btn:hover {
  background-color: #2563EB; /* Dunklere blaue Farbe */
}

.delete-btn {
  background-color: #EF4444; /* Rote Farbe */
}

.delete-btn:hover {
  background-color: #DC2626; /* Dunklere rote Farbe */
}

.restore-btn {
  background-color: #10B981; /* Grüne Farbe */
}

.restore-btn:hover {
  background-color: #059669; /* Dunklere grüne Farbe */
}

.complete-btn {
  background-color: #10B981; /* Grüne Farbe */
}

.complete-btn:hover {
  background-color: #059669; /* Dunklere grüne Farbe */
}

.remove-btn {
  background-color: #0f5740; /* Graue Farbe */
}

.remove-btn:hover {
  background-color: #4B5563; /* Dunklere graue Farbe */
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* Halbtransparenter dunkler Hintergrund */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal Fenster */
/* Modal Fenster */
.modal {
  background-color: #1F2937;
  padding: 30px;
  border-radius: 10px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh; /* Maximale Höhe auf 80% der Bildschirmhöhe setzen */
  overflow-y: auto; /* Scrollen ermöglichen, wenn der Inhalt zu groß ist */
}

.modal h2 {
  font-size: 1.75rem;
  margin-bottom: 20px;
  color: #F3F4F6; /* Heller Text */
}


.modal label {
  display: block;
  margin-bottom: 15px;
  color: #D1D5DB; /* Heller Text */
}

.modal input,
.modal textarea {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #374151;
  background-color: #111827; /* Sehr dunkler Hintergrund */
  color: #F3F4F6; /* Heller Text */
  font-size: 1rem;
}

.modal-buttons {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

/* Modal Schaltflächen */
.modal-buttons button {
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  font-size: 1rem;
  color: white;
  cursor: pointer;
}

.modal-buttons button:first-child {
  background-color: #3B82F6; /* Blaue Farbe */
}

.modal-buttons button:first-child:hover {
  background-color: #2563EB; /* Dunklere blaue Farbe */
}

.cancel-btn {
  background-color: #6B7280; /* Graue Farbe */
}

.cancel-btn:hover {
  background-color: #4B5563; /* Dunklere graue Farbe */
}

/* Aktions-Schaltflächen */
.actions {
  display: flex;
  gap: 10px;
  margin-top: 30px;
}

.add-btn {
  background-color: #3B82F6;
}

.add-btn:hover {
  background-color: #2563EB;
}

.submit-btn {
  background-color: #10B981;
}

.submit-btn:hover {
  background-color: #059669;
}

/* Stil für das Input-Feld */
.search-input {
  margin-top: 20px;
  width: 100%;
  max-width: 400px;
  padding: 10px 15px;
  border-radius: 8px;
  border: 1px solid #374151; /* Dunkler Rand */
  background-color: #1F2937; /* Dunkler Hintergrund */
  color: #F3F4F6; /* Heller Text */
  font-size: 1rem;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.search-input::placeholder {
  color: #9CA3AF; /* Hellere Farbe für Platzhaltertext */
}

.search-input:focus {
  outline: none;
  border-color: #3B82F6; /* Blaue Farbe bei Fokus */
}

  </style>